export default __webpack_public_path__ + "static/media/2.76e89a42.jpg";